import { Component } from '@angular/core';
import { LeaderboardType } from '@fgb/core';

@Component({
  selector: 'fgb-trivia-leaderboard-page',
  templateUrl: './trivia-leaderboard-page.component.html',
  styleUrl: './trivia-leaderboard-page.component.scss',
})
export class TriviaLeaderboardPageComponent {
  LeaderboardType: LeaderboardType = LeaderboardType.TriviaPoints;
}
